import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  userRoutes = JSON.parse(localStorage.getItem('userRoutes'));

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.apiService.getRoutes().subscribe(
      data => {
        this.userRoutes = JSON.parse(localStorage.getItem('userRoutes'));
      },
      err => {
        console.log(err);
      }
    );
  }

}
